import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs';
import { CHIP_TYPES } from './chip.interface';

@Component({
  selector: 'app-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ChipComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<null>();

  @Input() name: string = '';
  @Input() type: CHIP_TYPES = CHIP_TYPES.DEFAULT;
  @Input() isSelected: boolean = false;
  @Input() isDisabled: boolean = false;
  @Input() isClose: boolean = false;
  @Input() noWrap: boolean = false;
  @Output() onChangeSelect = new EventEmitter();
  @Output() onChangeClose = new EventEmitter();

  protected readonly CHIP_TYPES = CHIP_TYPES;

  constructor() {}

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  public toggleSelection(): void {
    this.isSelected = !this.isSelected;
    this.onChangeSelect.emit(this.isSelected);
  }
}
